module.exports = __webpack_public_path__ + "img/logo.9cdf53c5.png";